export default {
  type: '',
  defaultGroup: 3, // title names   331 maturity code  333 description method
  categoryGroups: [
    { GcCode: 1, SortOrder: 1 }, // Mineral soils
    { GcCode: 2, SortOrder: 2 }, // Organic soils
    { GcCode: 3, SortOrder: 3 }, // Other
    { GcCode: 4, SortOrder: 4 } // Stones
  ],
  codes: [
    // Mineral soils
    { categoryGroup: 1, sortOrderInGroup: 1, primaryGcCode: 'K', primaryRemark: 'Clay', disableColumnOption: { primary: [], additive1: ['E', 'T', 'H', 'O', 'C', 'A', 'D', 'L', 'V', 'R', '16', 'K', 'Z', 'M'], additive1Gradation: ['0'], organic: ['0', '4'], additive3Gradation: ['0', '4'], consistency: ['2', '5', '8', '9'], plasticity: [] } },
    { categoryGroup: 1, sortOrderInGroup: 2, primaryGcCode: 'J', primaryRemark: 'Silt', disableColumnOption: { primary: [], additive1: ['E', 'T', 'G', 'H', 'O', 'C', 'A', 'D', 'L', 'V', 'R', '16', 'K', 'Z', 'M'], additive1Gradation: ['0'], organic: ['0', '4'], additive3Gradation: ['0', '4'], consistency: ['2', '5', '8', '9'], plasticity: [] } },
    { categoryGroup: 1, sortOrderInGroup: 3, primaryGcCode: 'Z', primaryRemark: 'Sand', disableColumnOption: { primary: [], sandmedian: ['1', '2', '3', '4', '5', '6', '13'], additive1: ['E', 'T', 'H', 'O', 'C', 'A', 'D', 'L', 'V', 'R', '16', 'Z', 'M'], additive1Gradation: ['0'], organic: ['0', '4'], additive3Gradation: ['0', '4'] } },
    { categoryGroup: 1, sortOrderInGroup: 4, primaryGcCode: 'G', primaryRemark: 'Gravel', disableColumnOption: { primary: [], gravelmedian: ['1', '2', '3'], additive1: ['H', 'G', 'O', 'C', 'A', 'D', 'L', 'V', 'R', '16', 'M'], additive1Gradation: ['0'], organic: ['0', '4'] } },

    // Organic soils
    { categoryGroup: 2, sortOrderInGroup: 1, primaryGcCode: 'H', primaryRemark: 'Humus', disableColumnOption: { primary: [], additive1: ['E', 'T', 'S', 'H', 'G', 'O', 'C', 'A', 'D', 'L', 'V', 'R', '16'], consistency: ['2', '5', '7', '8', '9'] } },
    { categoryGroup: 2, sortOrderInGroup: 2, primaryGcCode: 'Y', primaryRemark: 'Gyttja', disableColumnOption: { primary: [], additive1: ['E', 'T', 'S', 'H', 'G', 'O', 'C', 'A', 'D', 'L', 'V', 'R', '16'], consistency: ['2', '5', '7', '8', '9'] } },
    { categoryGroup: 2, sortOrderInGroup: 3, primaryGcCode: 'F', primaryRemark: 'Detritus', disableColumnOption: { primary: [], additive1: ['E', 'T', 'S', 'H', 'G', 'O', 'C', 'A', 'D', 'L', 'V', 'R', '16'], consistency: ['2', '5', '7', '8', '9'] } },
    { categoryGroup: 2, sortOrderInGroup: 4, primaryGcCode: 'V', primaryRemark: 'Peat', disableColumnOption: { primary: [], additive1: ['E', 'T', 'S', 'H', 'G', 'O', 'C', 'A', 'D', 'L', 'V', 'R', '16'], consistency: ['2', '5', '7', '8', '9'] } },

    // Others
    { categoryGroup: 3, sortOrderInGroup: 1, primaryGcCode: 'S', primaryRemark: 'Alluvium', disableColumnOption: { primary: [], maturity: [] } },
    { categoryGroup: 3, sortOrderInGroup: 2, primaryGcCode: 'W', primaryRemark: 'Water' },

    // Rocks
    { categoryGroup: 4, sortOrderInGroup: 1, primaryGcCode: '31', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 2, primaryGcCode: '40', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 3, primaryGcCode: '59', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 4, primaryGcCode: '44', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 5, primaryGcCode: '62', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 6, primaryGcCode: '63', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 7, primaryGcCode: '29', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 8, primaryGcCode: '28', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 9, primaryGcCode: '30', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 10, primaryGcCode: '22', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 11, primaryGcCode: '38', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 12, primaryGcCode: '43', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 13, primaryGcCode: '55', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 14, primaryGcCode: '26', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 15, primaryGcCode: '42', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 16, primaryGcCode: '60', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 17, primaryGcCode: '45', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 18, primaryGcCode: '35', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 19, primaryGcCode: '64', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 20, primaryGcCode: '34', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 21, primaryGcCode: '50', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 22, primaryGcCode: '56', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 23, primaryGcCode: '27', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 24, primaryGcCode: '25', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 25, primaryGcCode: '49', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 26, primaryGcCode: '47', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 27, primaryGcCode: '48', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 28, primaryGcCode: '51', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 29, primaryGcCode: '53', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 30, primaryGcCode: '37', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 31, primaryGcCode: '46', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 32, primaryGcCode: '24', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 33, primaryGcCode: '33', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 34, primaryGcCode: '32', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 35, primaryGcCode: '41', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 36, primaryGcCode: '58', primaryRemark: '' },
    { categoryGroup: 4, sortOrderInGroup: 37, primaryGcCode: '23', primaryRemark: '' }
  ],
  /**
     * A mapping between the dsFieldsProject->tblLayer to a key of the CODES->disableColumnOption->KEY
     */
  mappings: {
    primary: {
      dbField: 'LaSoilTypeCode',
      codeList: { key: 'MainTypes', sort: 'GcShortCode' }
    },
    median: {
      dbField: 'LaMedianCode',
      codeList: { key: 'Median', sort: 'GcCode' }
    },

    additive1: {
      dbField: 'LaAd1TypeCode',
      codeList: { key: 'Additions', sort: 'GcShortCode' }
    },

    additive1Gradation: {
      dbField: 'LaAd1GradationCode',
      codeList: { key: 'Gradients', sort: 'GcCode' }
    },

    organic: {
      dbField: 'LaAd2GradationCode',
      codeList: { key: 'Gradients', sort: 'GcCode' }
    },

    additive3Gradation: {
      dbField: 'LaAd3GradationCode',
      codeList: { key: 'Gradients', sort: 'GcCode' }
    },

    consistency: {
      dbField: 'LaConsistencyCode',
      codeList: { key: 'Consistency', sort: 'GcCode' }
    },

    plasticity: {
      dbField: 'LaTexturePlasticityCode',
      codeList: { key: 'Plasticity', sort: 'GcCode' }
    },

    maturity: {
      dbField: 'LaMaturityCode',
      codeList: { key: 'Maturity', sort: 'GcCode' }
    }
  }
}
